const SectionHeader = ({ overline, title, subtitle, align = "left", testid }) => {
  return (
    <div
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
      data-testid={testid}
    >
      {overline && <div className="overline mb-4">{overline}</div>}
      <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight text-balance text-[hsl(var(--foreground))]">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-5 text-base sm:text-lg text-[hsl(var(--muted-foreground))] leading-relaxed max-w-2xl">
          {subtitle}
        </p>
      )}
      <div className={`h-[2px] w-14 bg-[hsl(var(--accent))] mt-6 ${align === "center" ? "mx-auto" : ""}`} />
    </div>
  );
};

export default SectionHeader;
